import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { AlertTriangle, RotateCcw } from 'lucide-react';

const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

export const OrphanSitesCard = ({ orphans, onRestore }) => {
  if (!orphans || orphans.length === 0) return null;
  return (
    <Card className="border-amber-300 bg-amber-50 shadow-sm" data-testid="orphan-sites-card">
      <CardContent className="p-5">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <h3 className="font-semibold text-amber-900">
              {orphans.length === 1 ? 'Cantiere eliminato con rapporti collegati' : `${orphans.length} cantieri eliminati con rapporti collegati`}
            </h3>
            <p className="text-sm text-amber-800 mt-1">
              Questi cantieri non esistono più in anagrafica ma hanno ancora rapporti associati. Ripristinandoli, i rapporti tornano collegati e filtrabili.
            </p>
            <div className="mt-4 space-y-2">
              {orphans.map((o) => (
                <div key={o.site_id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 bg-white rounded-md border border-amber-200 px-4 py-3" data-testid={`orphan-site-${o.site_id}`}>
                  <div className="min-w-0">
                    <p className="font-medium text-slate-800 truncate" data-testid={`orphan-site-name-${o.site_id}`}>
                      {o.suggested_name || 'Cantiere senza nome (recuperabile manualmente)'}
                    </p>
                    <p className="text-xs text-slate-500 mt-0.5" data-testid={`orphan-site-count-${o.site_id}`}>
                      {o.report_count} {o.report_count === 1 ? 'rapporto' : 'rapporti'}
                      {o.first_date && ` · dal ${formatDate(o.first_date)} al ${formatDate(o.last_date)}`}
                      {o.report_numbers?.length > 0 && ` · nn. ${o.report_numbers.join(', ')}${o.report_count > o.report_numbers.length ? '…' : ''}`}
                    </p>
                  </div>
                  <Button size="sm" className="btn-primary flex-shrink-0" onClick={() => onRestore(o)} data-testid={`restore-site-btn-${o.site_id}`}>
                    <RotateCcw className="w-4 h-4 mr-1" />
                    Ripristina
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
